
<template>
  <ConfirmationModal
    :key="componentKey"
    :title="$t('AUTH_MODAL_TITLE')"
    :confirm-action-text="$t('CONFIRM_BUTTON')"
    :confirm-button-loading="isLoading"
    @confirm="onConfirm()"
    @close="onCloseModal()"
    @dismiss="onDismissModal()"
  >
    <ValidationObserver
      ref="formValidation"
      slim
    >
      <form
        role="form"
      >
        <fieldset v-if="authType == 'password'">
          <Field
            :label="$t('INPUT_EMAIL')"
          >
            <template #element>
              <ValidationProvider
                v-slot="{ errors }"
                slim
                rules="required|email"
              >
                <div
                  class="row"
                  :class="{
                    'ng-invalid ng-submitted': errors.length > 0
                  }"
                >
                  <div class="col-sm-6 col-md-6 col-xs-10">
                    <input
                      id="emailInput"
                      v-model="email"
                      type="email"
                      autocomplete="off"
                      class="form-control"
                      required="true"
                      :class="{
                        'ng-invalid ng-touched': errors.length > 0
                      }"
                    >
                    <span
                      v-if="errors.length > 0"
                      v-t="'INPUT_EMAIL_ERROR_DESCRIPTION'"
                      class="text-danger" 
                    />
                  </div>
                  <label 
                    v-t="'REQUIRED_LABEL'"
                    class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                  />
                </div>
              </ValidationProvider>
            </template>
          </Field>
          <Field
            :label="$t('INPUT_PASSWORD')"
          >
            <template #element>
              <ValidationProvider
                v-slot="{ errors }"
                slim
                rules="required"
              >
                <div
                  class="row"
                  :class="{
                    'ng-invalid ng-submitted': errors.length > 0
                  }"
                >
                  <div class="col-sm-6 col-md-6 col-xs-10">
                    <input
                      id="passwordInput"
                      v-model="password"
                      type="password"
                      autocomplete="off"
                      class="form-control"
                      required="true"
                      :class="{
                        'ng-invalid ng-touched': errors.length > 0
                      }"
                    >
                  </div>
                  <label 
                    v-t="'REQUIRED_LABEL'"
                    class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                  />
                </div>
              </ValidationProvider>
            </template>
          </Field>
        </fieldset>
        <fieldset v-if="authType == 'mfa'">
          <Field
            :label="$t('INPUT_MULTI_FACTOR_CODE')"
            :has-tooltip="true"
            :tooltip-text="$t('MULTI_FACTOR_AUTH_TT')"
          >
            <template #element>
              <ValidationProvider
                v-slot="{ errors }"
                slim
                rules="required"
              >
                <div
                  class="row"
                  :class="{
                    'ng-invalid ng-submitted': errors.length > 0
                  }"
                >
                  <div class="col-sm-6 col-md-6 col-xs-10">
                    <input
                      id="multiFactorAuthCodeInput"
                      v-model="multiFactorAuthCode"
                      type="text"
                      autocomplete="off"
                      class="form-control"
                      required="true"
                      :class="{
                        'ng-invalid ng-touched': errors.length > 0
                      }"
                    >
                  </div>
                  <label 
                    v-t="'REQUIRED_LABEL'"
                    class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                  />
                </div>
              </ValidationProvider>
            </template>
          </Field>
        </fieldset>
      </form>
    </ValidationObserver>
  </ConfirmationModal>
</template>

<script>

import messages from './locales';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import { accountUserService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'MultiFactorAuthModal',
  components: { ConfirmationModal, Field },
  props: {
    model: {
      type: Object,
      default() {
        return null;
      }    
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      componentKey: 0,
      multiFactorAuthCode: '',
      email: '',
      password: '',
      authType: 'password',
      passwordType: 'password'
    };
  },
  mounted() {
    this.getAuthenticationType();
  },
  methods: {
    showPassword() {
      if (this.passwordType === 'password') {
        this.passwordType = 'text';
      } else {
        this.passwordType = 'password';
      }
    },
    onConfirm(){
      this.$emit('confirm-modal', {
        multiFactorAuthCode: this.multiFactorAuthCode,
        model: this.model,
        email: this.email,
        password: this.password,
      });
    },
    onCloseModal() {
      this.$emit('close-modal');
      this.componentKey++;
    },
    onDismissModal() {
      this.onCloseModal();
    },
    getAuthenticationType() {
      let self = this;
      accountUserService.getAuthenticationType()
        .then(function(response) {
          self.authType = response.data.authType;
        })
        .catch(function() {
          self.authType = 'password';
        });
    }
  },
  
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>
.two-factor-auth-description {
  text-align: center;
}
</style>